<template>
  <div>

    <v-container fluid>
      ...redirecting


    </v-container>
  </div>
</template>
<script>
   export default {

      beforeCreate(){

         if (this.$auth.profile.acct_type === 'AGENCY'){
            if  (this.$auth.profile.user_role === 'Admin')
              this.$router.push('/home-admin');
            if  (this.$auth.profile.user_role === 'AcctManager')
               this.$router.push('/home-admin');
            if  (this.$auth.profile.user_role === 'Grader')
               this.$router.push('/grader-home');
         }
         else {
            this.$router.push('/grade-report');
         }
      }
   };
</script>
